import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {RespinIdleUIAct} from '@gongxigames/framework/slotV2/ui/acts/RespinIdleUIAct';

export class RespinIdleUIState extends UIState {
    public static readonly ID = 'RespinIdleUIState';

    public setAct(): void {
        this.act = sequence([
            RespinIdleUIAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.feature_type.value?.type === 'respinsIdle';
    }
}